import { render, staticRenderFns } from "./ModuleSingle.vue?vue&type=template&id=0a970a4b&scoped=true&"
import script from "./ModuleSingle.vue?vue&type=script&lang=js&"
export * from "./ModuleSingle.vue?vue&type=script&lang=js&"
import style0 from "./ModuleSingle.vue?vue&type=style&index=0&id=0a970a4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a970a4b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCardText,VDivider,VIcon,VToolbar,VToolbarTitle})
